import React from 'react';

interface IProps {
  style?: any;
}

const PlusIcon:React.FC<IProps> = (props: IProps) => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M14.1678 13.3094L23.17 13.3095L23.1701 10.5696H14.1569L14.1569 1.36984L11.417 1.36987L11.4171 10.3721L2.4148 10.3721L2.41477 13.112L11.4279 13.112L11.4279 22.3117L14.1678 22.3117L14.1678 13.3094Z" fill={props.style?.fillColor ? props.style.fillColor : "#204078"}/>
    </svg>
  )
}

export default PlusIcon;